module.exports = __webpack_public_path__ + "static/img/navigation.3806e576.png";